import React from 'react';
import { useOrderAdjustmentOrderAdjustmentTypeInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { IOrderAdjustment } from '../order-adjustment-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

interface IOrderAdjustmentTypeInput {
    // When locked (e.g. the Devoluciones page), the type is preselected and the
    // field is shown read-only so the user sees — but can't change — it.
    disabled?: boolean;
}

export function OrderAdjustmentTypeInput({
    disabled = false,
}: IOrderAdjustmentTypeInput = {}) {
    const { data } = useOrderAdjustmentOrderAdjustmentTypeInputQuery();
    const INPUT_NAME: keyof IOrderAdjustment = 'order_adjustment_type_id';

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.order_adjustment_type_id)}
            options={data?.getOrderAdjustmentTypes || []}
            disabled={disabled}
        />
    );
}
